import router from '@/router'
import store from '..'

export default ({
    state: {
        type: [
            {id: 'solo', lang: 'solo', value: 1 },
            {id: 'family', lang: 'family', value: 3 },
            {id: 'friends', lang: 'friends', value: 4 },
            {id: 'couples', lang: 'couples', value: 2 },
            {id: 'business', lang: 'business', value: 5 },
            {id: 'etc', lang: 'etc', value: 9 }
        ],


        range: [
            {emoji: 'rateLev_0.svg', label: '', lang: 'choose', value: 0},
            {emoji: 'rateLev_1.svg.svg', label: '', lang: 'terrible', value: 1}, //최악
            {emoji: 'rateLev_2.svg', label: '', lang: 'poor', value: 2}, // 별로
            {emoji: 'rateLev_3.svg', label: '', lang: 'average', value: 3}, // 무난
            {emoji: 'rateLev_4.svg', label: '', lang: 'very_good', value: 4}, // 좋음
            {emoji: 'rateLev_5.svg', label: '', lang: 'excellent', value: 5}, // 아주좋음
        ],

        checklist: [
            {id: 'location', label: '위치', lang: 'location', value: 0},
            {id: 'service', label: '서비스', lang: 'service', value: 0},
            {id: 'clean', label: '청결도', lang: 'clean', value: 0},
            {id: 'amenity', label: '시설', lang: 'amenity', value: 0},
        ],

        ad: {
            link: '',
            image: ''
        },

        customItems: []
    },
    mutations: {
        insertAd(state, payload){
            const ad = {
                link: payload.link?payload.link:'',
                image: payload.image?payload.image:'',
            }
            state.ad = {...ad};
        },
        insertCustomItems(state, payload){
            state.customItems = [...payload];
        }
    },
    actions: {
        async fetchCustomItem({dispatch, commit}, {key}){

            try {
                const {status=999, message} = await dispatch('postReview', {
                    cmd: "sc-review",
                    func: "get-review-custom-items",
                    data: {
                        key
                    }
                });
                const {items=[]} = typeof(message)==='object' ? message : {};
                commit('insertCustomItems', items)
                return {status, items};
            } catch (error) {
                console.log("error", error)
            }

        },
        async setReview({dispatch},payload){
            // console.log('[setReview]', payload)
            try {
                const result = await dispatch('postReview', {
                cmd: "sc-review",
                func: "set-checkout",
                data: payload
            });
                if(result.status===200){
                    router.push({ name: 'Finish' });
                }else{
                    throw 'API ERR';
                }

            } catch (error) {
                console.log("[setReview] ", error);
                alert('Please try again later.');
            }
        },
        async getAd({dispatch, commit}, payload){
            if(store.state.user.k){
                const params = {
                    cmd: "sc-ad",
                    func: "review-ad",
                    k : store.state.user.k
                }
                const result = await dispatch('postContents', params);
                commit('insertAd', result && result.message ? result.message:{link: '', image: ''})
                
                return result;
            }
            
        }
    },
    getters: {
        getReviewType: state=>{
            return state.type
        },
        getCheckList: state=>{
            return state.checklist
        },
        getRange: state=>{
            return state.range
        },
        getGuestType: state=>{
            return state.type
        },
        getAdObj: state=> state.ad,

        getCustomItems: state=>{
            console.log("state.customItems", state.customItems)
            return state.customItems.reduce((result, x)=>{
                
                result[x.key] = {
                    value: {},
                    options: x.value.map(option=>{
                        return {
                            id: option.itemValueKey, 
                            itemValueKey: option.itemValueKey,
                            label: option.display,
                            key: x.key,
                            handWriting: option.handWriting,
                            text: '',
                        }
                    }),
                    display: x.display,
                    type: x.type
                }
                return result;
            }, {})
        }
    }
})

